import styled from '@mui/system/styled';
import { Card } from '@mui/material';
import { t } from 'i18next';
import { BookingTypeEnum } from '../../../../../redux/booking/bookingSlice';

export const StyledBookingTypeCard = styled(Card)`
  border-radius: 5px;
  padding: 3px 20px 3px 20px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  margin: 0 10px 0 10px;
  transition: 0.3s;
  no-wrap: true;
  text-align: center;
  box-shadow: none;

  @media (max-width: 1100px) {
    padding: 5px 5px 5px 5px;
    margin: 0 5px 0 5px;
    height: min-content;
    font-size: 10px;
    font-weight: 500;
    min-width: 100px;
  }
`;

export default function BookingType({ type }: { type: BookingTypeEnum }) {
  return (
    <StyledBookingTypeCard
      sx={{
        color: type === BookingTypeEnum.ONLINE ? '#57B15A' : 'rgb(51, 110, 107, 0.7)',
        bgcolor:
          type === BookingTypeEnum.ONLINE ? 'rgba(87, 177, 90, 0.15)' : 'rgb(146, 207, 205, 0.5)',
      }}
    >
      {type === BookingTypeEnum.ONLINE ? t('bookings.online') : t('bookings.inPerson')}
    </StyledBookingTypeCard>
  );
}
